import type { Assignment } from "../SettingsPayload";

/** 今回の実行で担当が呼ばれない理由。呼ばれるなら null。 */
export type InertReason = "skip" | "allTargetsSkipped" | "noTargets";

/**
 * この担当が今回の実行で呼ばれない理由を返す。
 *
 * 理由を分けるのは画面の文言のためで、明示のスキップと導出（全対象が書き込み対象外）を
 * 同じ文で説明すると、利用者がどちらを直せばよいか分からなくなる。実機で明示スキップの
 * 担当に導出側の文言が出て、それが分かった。
 */
export function assignmentInertReason(assignment: Assignment): InertReason | null {
    if (assignment.skip === true) return "skip";
    if (assignment.targets.length === 0) return "noTargets";
    const skipped = new Set(assignment.skipTargets ?? []);
    return assignment.targets.every((ref) => skipped.has(ref)) ? "allTargetsSkipped" : null;
}
